(function () {
  function initFeaturedMediaByUrl() {
    const queryString = window.location.search; // e.g. "?v=sub"
    if (!queryString) return;

    // Har product-media-gallery block apna alag <media-gallery> rakhta hai
    document.querySelectorAll('media-gallery').forEach((mediaGallery) => {
      const gallery = mediaGallery.querySelector('slideshow-component');
      if (!gallery) return;

      // Slide order == sorted_media order jo Liquid ne render kiya
      const images = Array.from(gallery.querySelectorAll('.product-media__image'));

      const targetIndex = images.findIndex(
        (img) => img.alt && img.alt.trim() === queryString.trim()
      );

      if (targetIndex === -1) return;

      // Component ready hone ka wait karo, phir index select karo
      customElements.whenDefined('slideshow-component').then(() => {
        // select() ke andar refs.slides available hona chahiye
        requestAnimationFrame(() => {
          gallery.select(targetIndex, undefined, { animate: false });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedMediaByUrl);
  } else {
    initFeaturedMediaByUrl();
  }
})();